// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/synopsis/bgLines.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-basis {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), var(--primary-color);
  min-height: 100vh;
  padding: 3.125rem;
  /* padding: 0 3.125rem 3.125rem 3.125rem; */
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1rem;
}
.store-basis h1 {
  margin-bottom: 3rem;
}

.store-basis h1,
.store-basis h4,
.store-basis p {
  color: white !important;
}

.store-basis p {
  font-size: 1rem;
}
.store-basis .basis-card {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.store-basis .drop-shadow-card {
  background: linear-gradient(
    118.01deg,
    rgba(242, 242, 242, 0.1) 9.66%,
    rgba(242, 242, 242, 0.1) 67.65%
  );
  box-shadow: 0px 0.25rem 20.313rem rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(0.625rem);
          backdrop-filter: blur(0.625rem);
  min-height: 23.75rem;
  padding: 1.875rem !important;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  border-radius: 1rem;
  /* justify-content: space-around;
  flex-direction: column; */
}
.flex-header h1 {
  font-size: 1.5rem !important;
}
.store-basis .flex-header p {
  margin-bottom: 0;
  font-size: 0.813rem;
}
.store-basis .flex-header img {
  margin-right: 0.625rem;
  width: 1.875rem;
}

.store-basis .ant-divider {
  border-color: white;
}
/* .store-basis .ant-progress-circle-trail {
  stroke: transparent !important;
} */
.store-basis .ant-progress-inner {
  width: 12.25rem !important;
  height: 12.25rem !important;
  /* position: relative; */
}
.store-basis .progress-section {
  position: relative;
}
.store-basis .progress-section p {
  position: absolute;
  top: 30%;
  text-align: center;
  left: 15%;
  /* margin-left: -50.313rem; */
  font-size: 0.875rem;
}
.store-basis .ant-divider-vertical {
  height: 100%;
  border-width: 0.125rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/storecard.css"],"names":[],"mappings":"AAAA;EACE,yEAA0E;EAC1E,iBAAiB;EACjB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;;;;GAIC;EACD,oDAAoD;EACpD,uCAA+B;UAA/B,+BAA+B;EAC/B,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB;2BACyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;;GAEG;AACH;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB","sourcesContent":[".store-basis {\n  background: url('../../assets/synopsis/bgLines.png'), var(--primary-color);\n  min-height: 100vh;\n  padding: 3.125rem;\n  /* padding: 0 3.125rem 3.125rem 3.125rem; */\n  margin-bottom: 3rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 1rem;\n}\n.store-basis h1 {\n  margin-bottom: 3rem;\n}\n\n.store-basis h1,\n.store-basis h4,\n.store-basis p {\n  color: white !important;\n}\n\n.store-basis p {\n  font-size: 1rem;\n}\n.store-basis .basis-card {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.store-basis .drop-shadow-card {\n  background: linear-gradient(\n    118.01deg,\n    rgba(242, 242, 242, 0.1) 9.66%,\n    rgba(242, 242, 242, 0.1) 67.65%\n  );\n  box-shadow: 0px 0.25rem 20.313rem rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(0.625rem);\n  min-height: 23.75rem;\n  padding: 1.875rem !important;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-around;\n  border-radius: 1rem;\n  /* justify-content: space-around;\n  flex-direction: column; */\n}\n.flex-header h1 {\n  font-size: 1.5rem !important;\n}\n.store-basis .flex-header p {\n  margin-bottom: 0;\n  font-size: 0.813rem;\n}\n.store-basis .flex-header img {\n  margin-right: 0.625rem;\n  width: 1.875rem;\n}\n\n.store-basis .ant-divider {\n  border-color: white;\n}\n/* .store-basis .ant-progress-circle-trail {\n  stroke: transparent !important;\n} */\n.store-basis .ant-progress-inner {\n  width: 12.25rem !important;\n  height: 12.25rem !important;\n  /* position: relative; */\n}\n.store-basis .progress-section {\n  position: relative;\n}\n.store-basis .progress-section p {\n  position: absolute;\n  top: 30%;\n  text-align: center;\n  left: 15%;\n  /* margin-left: -50.313rem; */\n  font-size: 0.875rem;\n}\n.store-basis .ant-divider-vertical {\n  height: 100%;\n  border-width: 0.125rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
